import React from 'react';
import { t } from 'i18next';

import './index.less';

import IbTypography from '../../../../../components/common/IbTypography';
import IbIcon from '../../../../../components/common/IbIcon';
import { ELMA365ToolModel } from '../../../../../../gamma-api';
import { ELMA365_TOOL_ACTION_ICON_NAMES, ELMA365_COMPONENT_TYPE_ICON_NAMES } from '../../const';
import { getToolActionTypeDisplayText } from '../../utils';
import { getTranslateFunc } from '../../../../../utils/stringUtil';

import {
  MAIN_CLASS_NAME,
  COLUMN_CLASS_NAME,
  TITLE_CELL_COLUMN_CLASS_NAME,
  COMPONENT_CELL_COLUMN_CLASS_NAME,
} from './const';

export interface IToolInfoBarProps {
  tool: ELMA365ToolModel;
}

const ToolInfoBar: React.FC<IToolInfoBarProps> = ({ tool }) => {
  const translate = getTranslateFunc('Toolkits: ELMA365: Tool: Info bar:');

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={`${COLUMN_CLASS_NAME} ${TITLE_CELL_COLUMN_CLASS_NAME}`}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate('Namespace')}
        </IbTypography.Paragraph>
        <IbTypography.Paragraph ellipsis type="secondary">
          {tool.namespace.identity.name}
        </IbTypography.Paragraph>
      </div>
      <div className={`${COLUMN_CLASS_NAME} ${COMPONENT_CELL_COLUMN_CLASS_NAME}`}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate(tool.component.identity.type)}
        </IbTypography.Paragraph>
        <IbIcon iconName={ELMA365_COMPONENT_TYPE_ICON_NAMES[tool.component.identity.type]} size={20} />
        <IbTypography.Paragraph ellipsis type="secondary">
          {tool.component.identity.name}
        </IbTypography.Paragraph>
      </div>
      <div className={COLUMN_CLASS_NAME}>
        <IbTypography.Paragraph disabled type="secondary">
          {translate('Action')}
        </IbTypography.Paragraph>
        <IbIcon iconName={ELMA365_TOOL_ACTION_ICON_NAMES[tool.action]} size={20} />
        <IbTypography.Paragraph ellipsis type="secondary">
          {getToolActionTypeDisplayText(tool.action, t)}
        </IbTypography.Paragraph>
      </div>
    </div>
  );
};

export default ToolInfoBar;
